import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import { localTenantChanged } from "../tenant/tenantSlice";

export type PortalCredentials = {
  accessToken: string;
  accessExpiresAt: string;
  refreshExpiresAt: string;
};

export type AuthState = {
  credentials: PortalCredentials | null;
};

const initialState: AuthState = { credentials: null };

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    credentialsReceived(state, { payload }: PayloadAction<PortalCredentials>) {
      const { accessToken, accessExpiresAt, refreshExpiresAt } = payload;
      state.credentials = { accessToken, accessExpiresAt, refreshExpiresAt };
    },
    signedOut: () => initialState,
  },
  extraReducers: (builder) => {
    builder.addCase(localTenantChanged, () => initialState);
  },
});

export const { credentialsReceived, signedOut } = authSlice.actions;
export const authReducer = authSlice.reducer;
